var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Image as RebassImage } from 'rebass';
export default function StyledImage(_a) {
    var ref = _a.ref, src = _a.src, placeholder = _a.placeholder, props = __rest(_a, ["ref", "src", "placeholder"]);
    var _b = React.useState(false), error = _b[0], setError = _b[1];
    // Trigger image loading to catch error and prevent rendering the image
    React.useEffect(function () {
        var _a;
        var image = new Image();
        if (src)
            _a = [src, function () { return setError(true); }, function () { return setError(false); }], image.src = _a[0], image.onerror = _a[1], image.onload = _a[2];
    }, [src]);
    return React.createElement(React.Fragment, null, error && placeholder ? placeholder : React.createElement(RebassImage, __assign({ src: src }, props)));
}
